import React from "react"
import PropTypes from "prop-types"
import {FormattedMessage, FormattedCurrency} from "@irati/utils/lang"
import LimitInfo from "../styled/LimitInfo"

const MaxAmountReached = ({maxPrice, currency}) =>
  (<LimitInfo>
    <FormattedMessage id="perks.components.productForms.maxAmountReached.textFirstPart" />
    <FormattedCurrency isCents={false} value={maxPrice} currency={currency} />
    <FormattedMessage id="perks.components.productForms.maxAmountReached.textLastPart" />
  </LimitInfo>)

MaxAmountReached.propTypes = {
  maxPrice: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired
}

export default MaxAmountReached
